<section class="flex flex-col p-30">
    <app-product-training class="flex-none w-full h-full mx-auto max-w-1280"></app-product-training>
</section>